import React from 'react';
import { Switch } from "react-router";
import PrivateRoute from '@shared/routing/PrivateRoute';
import { RoomFinderPage } from "./pages/RoomFinderPage";
import { RoomBookings } from "./pages/RoomBookings";
import { HospitalityOrdersPage } from "./pages/HospitalityOrdersPage";

export function MeetingRoomRouter(props: Props) {
  return (
    <Switch>
      <PrivateRoute exact path="/meeting-rooms" component={RoomFinderPage}/>
      <PrivateRoute exact path="/meeting-rooms/my-bookings" component={RoomBookings}/>
      <PrivateRoute exact path="/meeting-rooms/hospitality-orders" component={HospitalityOrdersPage}/>
    </Switch>
  )
}

interface Props {
}
